import React, { useEffect } from 'react';
import { create } from 'zustand';

const useTenantStore = create((set, get) => ({
    tenantConfig: null,
    loadingTenant: true,
    tenantError: null,

    setTenantConfig: (config) => set({ tenantConfig: config }),

    fetchTenantConfig: async () => {
        try {
            const currentDomain = window.location.hostname;
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            
            const response = await fetch(`${apiUrl}/api/v2/public/tenant-config?domain=${currentDomain}`);
            
            if (!response.ok) {
                throw new Error('Error al obtener la configuración de la empresa');
            }

            const data = await response.json();
            set({ tenantConfig: data, loadingTenant: false });
        } catch (error) {
            console.error("Error cargando configuración del tenant:", error);
            set({
                tenantError: "No se pudo cargar la configuración de la plataforma.",
                tenantConfig: {
                    id_empresa: 1,
                    nombre: "Sistema de Gestión",
                    dominio: window.location.hostname
                },
                loadingTenant: false
            });
        }
    },

    updateTenantById: async (id_empresa) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const response = await fetch(`${apiUrl}/api/v2/public/tenant-config?id_empresa=${id_empresa}`);
            if (response.ok) {
                const data = await response.json();
                set({ tenantConfig: data });
            }
        } catch (error) {
            console.error("Error actualizando configuración del tenant por ID:", error);
        }
    }
}));

export const useTenant = () => useTenantStore();

export const TenantProvider = ({ children }) => {
    const fetchTenantConfig = useTenantStore(state => state.fetchTenantConfig);
    const loadingTenant = useTenantStore(state => state.loadingTenant);
    const tenantError = useTenantStore(state => state.tenantError);
    const tenantConfig = useTenantStore(state => state.tenantConfig);

    useEffect(() => {
        fetchTenantConfig();
    }, [fetchTenantConfig]);

    if (loadingTenant) {
        return (
            <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ border: '4px solid #f3f3f3', borderTop: '4px solid #3b82f6', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
                    <p style={{ marginTop: '16px', color: '#6b7280', fontFamily: 'system-ui, sans-serif' }}>Cargando plataforma...</p>
                    <style>
                        {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
                    </style>
                </div>
            </div>
        );
    }

    if (tenantError && !tenantConfig) {
        return (
            <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fef2f2' }}>
                <div style={{ textAlign: 'center', color: '#991b1b', padding: '20px' }}>
                    <h2>Error de Conexión</h2>
                    <p>{tenantError}</p>
                    <button onClick={() => window.location.reload()} style={{ marginTop: '10px', padding: '8px 16px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};
